var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#05BC86"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1671_10788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5195 15.8574L13.6621 19.7148L14.6697 20.7223L16.807 18.585V25.6637H18.2319V18.585L20.3693 20.7223L21.3768 19.7148L17.5195 15.8574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2177 15.5666C23.1334 12.4575 20.578 9.9541 17.449 9.9541C16.0115 9.9541 14.6342 10.4859 13.5708 11.4515C12.6545 12.2835 12.0353 13.3773 11.7928 14.5756C10.9266 14.7619 10.1359 15.21 9.52412 15.8695C8.7768 16.6752 8.36523 17.7246 8.36523 18.8241C8.36523 21.2204 10.3148 23.17 12.7112 23.17C12.7168 23.17 12.7225 23.1699 12.7266 23.1699H13.4592V21.745H12.7207L12.7071 21.7451C11.0983 21.7429 9.79013 20.4334 9.79013 18.8241C9.79013 17.312 10.9691 16.0331 12.4741 15.9126L13.0655 15.8653L13.1261 15.2752C13.354 13.054 15.2124 11.379 17.449 11.379C19.8453 11.379 21.7949 13.3285 21.7949 15.7249V16.9717H22.8279C24.144 16.9717 25.2146 18.0424 25.2146 19.3584C25.2146 20.6744 24.144 21.7451 22.8279 21.7451L21.5811 21.7448V23.1698H22.8047C22.8125 23.1699 22.8202 23.1701 22.8279 23.1701C24.9297 23.1701 26.6396 21.4602 26.6396 19.3584C26.6396 17.3882 25.1371 15.7623 23.2177 15.5666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1671_10788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2743,
    height: 18.2743,
    fill: "white",
    transform: "translate(8.36523 8.67188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.4c23e0d7403bb797d65d421416d9429c.svg";
export { ForwardRef as ReactComponent };